module.exports = __webpack_public_path__ + "img/startNot.8b8be107.png";